
import { LanguageMessage } from './language-message';

/**
 * è±æè¯­è¨æ¶æ¯
 */
class LanguageMessageForEn implements LanguageMessage {
  yes = 'Yes';
  no = 'No';
  unsaveNotifyTitle = 'Exist unsave record. Do save operation or not?';
  clientNotifyTitle = 'System Prompt In The Frontend';
  serverNotifyTitle = 'System Prompt In The Backend';
  cancelApproveSuccess = 'Cancel Approve Success';
  cancelApproveFailed = 'Cancel Approve Failed';
  unallowEmptyProcessInstanceName = 'Process Instance Name Can Not Be Empty';
  unallowEmptyBizBillId = 'Biz Bill Id Can Not Be Empty';
  unallowEmptyChildBizBillId = 'Child Biz Bill Id Can Not Be Empty';
  bizDefKeyRequired = 'Biz Def Key can\'t be empty.';
  procInsIdRequired = 'Process instance Id can\'t be empty.';
  addChildFailed = 'Add Child Failed';
  addSiblingFailed = 'Add Sibling Failed';
  addSubChildFailed = 'Add Sub Child Failed';
  addSubSiblingFailed = 'Add Sub Sibling Failed';
  deleteFailed = 'Delete Failed';
  multiSaveFailed = 'MultiSave Failed';
  appendFailed = 'Append Failed';
  queryFailed = 'Query Failed';
  cancelFailed = 'Cancel Failed';
  updateFailed = 'Update Failed';
  addFailed = 'Add Failed';
  loadFailed = 'Load Failed';
  saveSuccess = 'Successfully saved!';
  saveFailed = 'Save failed!';
  deleteSuccess = 'Successfully deleted!';
  deleteFaild = 'Failed to delete!';
  confirmDeletion = 'Confirm deletion?';
  submitSuccess = 'Submit successfully!';
  submitFaild = 'Submit failed!';
  notifyTitle = 'System prompt';
  httpError = 'HTTP request error! Please check the server error!';
  gridDataNotSave = 'The current page data is not saved. Turning the page will result in data loss. Do you want to continue turning the page?';
  exitWithoutSave = 'There is unsaved data. Do you want to continue closing?';
  notSupportMenuType = 'Not supported menu type!';
  cancelWithoutSave = 'Exist unsaved change,Confirm to cancel?';
  plsSelectDeleteData = 'Please select the data to delete!';
  errorHierarchyKey = 'Incorrect ierarchy key';
  plsSelectParentNode = 'Please select parent node!';
  deleteChildFirst = 'Please delete the child nodes first!';
  incorrectHierarchyConfig = 'Hierarchy config is incorrect!';
  operationFailed = 'The operation failed.';
  plsSelectEditData = 'Please select the data you want to edit!';
  plsSelectViewData = 'Please select the data you want to view!';
  plsUploadFirst = 'Please upload attachment first!';
  defaultDialogTitle = 'Dialog';
  public changeToFirst = 'The first data.';
  public changeToLast = 'The last data.';
  public noProcessInstanceId = 'Please provide the process instance id.';
  public noDataExist = 'Data does not exist to access the edit state!';
  public noAttachment = 'There are no attachments to preview.';
  public confirm = 'Confirm';
  public cancel = 'Cancel';
  public plsSelectCopyData = 'Please select the data you want to copy!';
  public copyFieldsRequired = 'The copy fields can`t be empty!';
  public pathIsRequired = 'The request url can`t be empty!';
  public propsIsEmpty = 'The material has no props!';
  public historyAttachment = 'The history attachment can`t be delete!';
  public plsSelectDownloadAtt = 'Please select the attachment you want to download!';
  public noDownloadAtt = 'There are no attachments to download!';
  public plsCheckBatchEditRows = 'Please check the rows you want to edit!';
  public plsSelectDetailFormData = 'Please select a detail form data first!';
  public dataAndStateChanged = 'Are you sure you want to load the new data and switch to $1 state?';
  public dataChanged = 'Are you sure you want to load the data and discards the current modification?';
  public stateChanged = 'Are you sure you want to switch $1 state?';
  public defaultStateName = 'init';
  public copy = 'Copy detail message';
  public copySuccess = 'Copy success';
  public copyFailed = 'Copy failed';
  public roger = 'Roger';
  public appOrFuncIdRequired = 'No menu or application parameters are configured, please configure them in the designer.';
  public tableCanNotEmpty = 'can not empty.';
  public plsSelectRemoveAtt = 'Please select the attachment to delete!';
  public plsSelectUpdateRow = 'Please select the row where you want to update the attachment!';
  public hasChangeCheckFaild ='An error occurred while checking the page for unsaved changes! Please make sure the data has been saved. Do you want to continue closing?';
  public noParentData = 'Please select the parent data!';
}

export { LanguageMessageForEn };
